import React, { useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { useSliderContext } from "./context";
import useTranslate from "@default/hooks/use-translate";

export const Slider = ({ children }) => {
  const { emblaRef, emblaOptions, emblaApi, canScrollPrev, canScrollNext } =
    useSliderContext();
  const _t = useTranslate();


  const handlePrev = () => emblaApi.scrollPrev();
  const handleNext = () => emblaApi.scrollNext();

  if (!emblaOptions.active) {
    return children;
  }

  return (
    <>
      {canScrollPrev && (
        <button
          className="embla__click-overlay prev"
          aria-label={_t("accessibility.previous_slide")}
          onClick={handlePrev}
        />
      )}

      <div className="embla" ref={emblaRef}>
        <div className="embla__container">{children}</div>
      </div>

      {canScrollNext && (
        <button
          className="embla__click-overlay next"
          aria-label={_t("accessibility.next_slide")}
          onClick={handleNext}
        />
      )}
    </>
  );
};

export const Slide = ({ children }) => {
  const { emblaOptions } = useSliderContext();
  if (!emblaOptions.active) {
    return children;
  }

  return <div className="embla__slide">{children}</div>;
};

Slider.propTypes = {
  children: PropTypes.node.isRequired,
  options: PropTypes.shape({
    loop: PropTypes.bool,
  }),
};
